import {
  type DataSourceDefinition,
  type FiltersDefinition,
  type SortingsDefinition,
} from '@factorialco/f0-react'
import { HeadcountJobCatalogSelectorDocument } from 'generated/resources/graphql'
import { type RecordType } from '@factorialco/f0-react'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import { type SalaryRangeData } from 'modules/planning/types/headcount'
import { extractSalaryRange } from 'modules/planning/lib/extractSalaryRange'

export interface JobCatalogOption extends RecordType {
  id: string
  name: string
  salaryRange?: SalaryRangeData
}

const useHeadcountJobCatalogSource = () => {
  const source: DataSourceDefinition<JobCatalogOption, FiltersDefinition, SortingsDefinition> =
    useGraphqlDataSource(
      {
        document: HeadcountJobCatalogSelectorDocument,
        paginationType: 'infinite-scroll',
        fetchPolicy: 'cache-first',
        perPage: 25,
        search: { enabled: true },
        mapData: (data) =>
          data.jobCatalog.treeNodesConnection.nodes.map(
            (node): JobCatalogOption => ({
              id: node.uuid,
              name: node.jobCatalogTitle ?? node.name ?? '',
              salaryRange: extractSalaryRange(node),
            })
          ),
        mapPagination: (data) => {
          const connection = data.jobCatalog.treeNodesConnection
          return {
            total: connection.totalCount ?? 0,
            cursor: connection.pageInfo.endCursor ?? '0',
            hasNextPage: !!connection.pageInfo.hasNextPage,
          }
        },
        mapVariables: ({ pagination, search }) => ({
          first: pagination?.perPage ?? 25,
          after:
            pagination?.cursor && pagination.cursor !== '0' ? String(pagination.cursor) : undefined,
          search: search || undefined,
        }),
      },
      []
    )

  return { source }
}

export default useHeadcountJobCatalogSource
